import SignUpForm from "../Components/SignUpForm";

const NewUser = () => {
	return (
		<div>
			<SignUpForm />
		</div>
	);
};

export default NewUser;
